import { createSelector, createFeatureSelector } from '@ngrx/store';
import { SettingsState } from './settings.reducer';
import { FeatureKeys } from '../app.reducer';
import { AppointmentType, Department, IPortal } from '@signal/asp-data-commons';



export const selectSettingsFeature = createFeatureSelector<SettingsState>(FeatureKeys.SETTINGS);

 
export const selectSettings = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.settings
);

export const selectAllSettings = createSelector(
  selectSettingsFeature,
  (state: SettingsState) => state
);
export const selectSettingsLoaded = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.loaded
);


export const selectZipcodes = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.zipcodes.data
);
 
export const selectTimezones = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.timezones
);

export const time = createSelector(
  selectSettingsFeature,
  (state: SettingsState) => state.settings?.time
);

export const bannerTexts = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.settings?.portal
  );

  export const bannerTextsBasedOnDept = createSelector(
    bannerTexts,
    (state: IPortal,props:AppointmentType) => {
        if(props === AppointmentType.SERVICE && state){
          return {bannerBodyText : state.bannerBodyText, bannerTitleText: state.bannerTitleText};
        }
        else if(props === AppointmentType.DELIVERY && state){
          return {bannerBodyText : state.deliveryBannerBodyText, bannerTitleText: state.deliveryBannerTitleText};
        }
        else if(props === AppointmentType.TEST_DRIVE && state){
          return {bannerBodyText : state.testDriveBannerBodyText, bannerTitleText: state.testDriveBannerTitleText};
        }
        else if(props === AppointmentType.LEARNING && state){
          return {bannerBodyText : state.techCenterBannerBodyText, bannerTitleText: state.techCenterBannerTitleText}
        }
        else{
          return {bannerBodyText : 'testDrive.fromHereYoucanScheduleServiceForYourVehiclesText', bannerTitleText: 'testDrive.welcomeToTheAppointmentSchedulingPortal'};
        }
    }
  );
  export const pdiChecklist = createSelector(
    bannerTexts,
    (state: IPortal) => state?.pdiChecklist
  )
  export const transportOptRemote = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.settings?.department === Department.SERVICE && state.settings?.transport?.transportOptions?.find(transportOpt => transportOpt?.id === "RENTAL") || {}
  );

  export const transportChecked = createSelector(
    selectSettingsFeature,
    (state: SettingsState) => state.settings?.department === Department.SERVICE && state.settings?.transport?.transportOptions?.filter(transportOpt => (transportOpt?.id === "REMOTE"||transportOpt?.id === "PICKUP" ||transportOpt?.id ==="DELIVERY" )) || {}
  );
